//#region src/apiUrls.ts
var e = "https://printing.api.myparcel.nl", t = "https://printing.api.acceptance.myparcel.nl";
//#endregion
export { e as n, t };
